export let novemberAbbreviatedLowercase = "OdCFKb";
export default {novemberAbbreviatedLowercase};